export default "__VITE_ASSET__6RT5wv_Y__"